<div class="alert-chip" [class]="'alert-chip-' + severity">
  <ng-content></ng-content>
</div>
